<template>
    <div v-cloak>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <span class="title">
                        <b>Editar Produto</b>

                        <i class="fa fa-truck" style="float:right;margin-top:6px;font-size:21px;"></i>
                    </span>

                    <hr class="m-t-md">
                </div>
            </div>
            <div class="panel-body">
                <form id="form" style="margin-top:-30px;">
                    <div class="row form-group m-l-sm">
                        <div class="col-md-4">
                            <label for="name">Nome do Material</label>
                            <input type="text" class="form-control" name="name" v-model="product.name" id="name">
                        </div>

                        <div class="col-md-4">
                            <label for="">Sub Categoria</label>
                            <select type="text" class="form-control" name="sub_category_product_id" v-model="product.sub_category_product_id">
                                <option value="">Selecione...</option>
                                <option v-for="sub in subCategories" :key="sub.id" :value="sub.id">{{sub.description}}</option>
                            </select>
                        </div>
                    </div>
                    
                    <div class="row form-group m-l-sm"></div>
                        <div class="col-md-4">
                            <label for="pre_order">Pré-Venda</label>
                            <input type="checkbox" class="form-control" name="pre_order" v-model="product.pre_order" id="pre_order">
                            <small>Se o produto for um pré-venda, ele será exibido na página uma tag de pré-venda.</small>
                        </div>
                    </div>

                    <hr class="m-t-md m-b-md">

                    <div class="block text-right">
                        <router-link to="/product" class="btn btn-info m-r-sm">
                            <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <a class="btn btn-success" @click="save">
                            Salvar <i class="fa fa-save"></i>
                        </a>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                product: {
                    name: '',
                    sub_category_product_id: 0
                },
                subCategories:[{
                    id: 0,
                    name: ''
                }]
            };
        },
        methods: {
            getSubCategories () {
                const self = this

                const api = self.$store.state.api + 'subCategoryProduct?paginated=false'

                self.$http
                    .get(api)
                    .then( (response) => {
                        self.subCategories = response.data.data
                    })
            },
            getProduct: function () {
                const self = this;
                const api = self.$store.state.api + 'product/' + self.$route.params.id;

                self.$http
                    .get(api)
                    .then((response) => {
                        self.product = response.data;
                    })
                    .then( () => {
                        self.getSubCategories();
                    })
                    .catch((error) => {
                        self.$error('Não foi possível buscar as informações referente ao Produto');
                    });
            },
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'product/' + self.$route.params.id;

                self.$http
                    .put(api, {
                        name: self.product.name,
                        sub_category_product_id: self.product.sub_category_product_id,
                        pre_order: self.product.pre_order
                    })
                    .then((response) => {
                        self.$message(null, 'Produto atualizado com sucesso', 'success');
                        self.$router.push('/product');
                    })
                    .catch((error) => {
                        self.$error('Não foi possível atualizar o Produto');
                    })
            }
        },
        mounted: function () {
            this.getProduct();
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Product/Edit.vue